module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "chapter20"
    }
  }, [_c('h1', [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _c('a', {
    attrs: {
      "href": "#/003toc#ch20"
    }
  }, [_vm._v("Greens ’n’ Beans Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This simple vegetable soup gets its rich flavor from escarole, creamy white beans, and the rind from Parmigiano-Reggiano cheese. Although you can put everything directly into the slow cooker, I recommend the sauté at the beginning to develop the flavors of the onion and garlic.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("2 tablespoons extra-virgin olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1 large sweet onion, coarsely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("3 stalks celery, coarsely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("2 carrots, coarsely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("2 cloves garlic, minced")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("2 heads escarole, tough outer leaves removed, cut into 1-inch pieces (see savvy)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("2 cups small white beans, picked over for stones, soaked, or two 15-ounce cans small white beans, drained and rinsed (see savvy)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("4 cups vegetable or chicken broth")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("¼ cup chopped rind from Parmigiano-Reggiano, plus ½ cup freshly grated Parmigiano-Reggiano cheese for garnishing (optional)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Salt")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("heat the oil in a skillet over medium-high heat. Add the onion, celery, and carrots and sauté until the onion begins to soften. Add the garlic and continue to cook for about 2 minutes, until the vegetables are fragrant but not soft.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("transfer the contents of the skillet to the insert of a 5- to 7-quart slow cooker. Top the vegetables with the escarole, stir in the beans, and pour the broth over the escarole. Add the cheese rind (if using) and ½ teaspoon of pepper and stir to combine.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("cover the slow cooker and cook on low for 4 hours or on high for 2 hours. Remove the cover and season with salt and pepper. serve the soup garnished with freshly grated Parmigiano-Reggiano, if desired.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("serves 8")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "sidebar_head"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "image 1",
      "src": "images/image-01.jpg"
    }
  }), _vm._v(" bean savvy")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("If you are in a hurry and don’t have time to soak the beans overnight, canned beans will work. Make sure to rinse and drain them in a sieve before adding them to the cooker. ")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("escarole savvy")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("If escarole is pricey or not available, Swiss chard or Savoy cabbage are nice replacements. Chop the chard, including the stems, which will become tender during the long cooking process.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("slow-cooker addition")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Add 2 cups cooked chicken with the other ingredients and proceed as directed.")])]), _vm._v(" "), _c('p', {
    staticClass: "breakhere"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e570eb0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/026-chapter20.vue
// module id = 132
// module chunks = 0